import 'COMMON';
import { svgSpriteLoader } from 'Lib/svg-sprite-loader/svg-sprite-loader';
import 'Bem/site/img-loader/img-loader';
// import { whiteLabel } from 'Lib/white-label/white-label'; Скрываем до появления новой ЧГ корзины
import 'Bem/journal/test/test';

// window.whiteLabel = whiteLabel;

$(window).on('load', () => {
    const $btnStart = $('.test__btn-start');

    if ($btnStart) {
        $btnStart.click();
    }
});

$('.iq-test__screen1-btn-box').on('click', () => {
    $('.iq-test').addClass('iq-test_test-active');
});

svgSpriteLoader('/landing/iq-test/svg/sprite.svg?v=20180320');